import React, { useContext, useEffect, useState } from 'react'
import DatePicker from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css"
import { LanguageContext } from '../../context'
import Datetime from 'react-datetime'
import "react-datetime/css/react-datetime.css"
import moment from 'moment'
import 'moment/locale/fr'
import { DatePicker as RDatePicker, Stack, CustomProvider } from 'rsuite';
import 'rsuite/DatePicker/styles/index.css';
import frFR from 'rsuite/locales/fr_FR';
import { isBefore, isAfter, subDays  } from 'date-fns'
import { DATE_TIME_FORMAT } from '../../utils/constants'

const DateInput = ({ onChange, value, disabled, minDate, maxDate, className, id }) => {

  const handleChange = (e) => {
    if (e) {
      // convert date to DD/MM/YYYY HH:mm
      const dateString = moment(e).format(DATE_TIME_FORMAT)
      onChange({ target: { value: dateString } })
    } else {
      onChange({ target: { value: null } })
    }
  }
  const handleChangeTime = (e) => {
    if (e) {
      // convert date to DD/MM/YYYY HH:mm
      const dateString = moment(e).format(DATE_TIME_FORMAT)
      onChange({ target: { value: dateString } })
    }
  }

  // useEffect(() => {
  //   if (value) {
  //     setDate(new Date(value))
  //   }
  // }, [value])

  // const isDateValid = (date) => {
  //   return Boolean(date) && moment(date).isValid()
  // }
  // const valid = (current) => {
  //   if (isDateValid(minDate) && !isDateValid(maxDate)) {
  //     return current.isAfter(moment(minDate).subtract(1, 'days'))
  //   }
  //   if (!isDateValid(minDate) && isDateValid(maxDate)) {
  //     return current.isSameOrBefore(maxDate)
  //   }
  //   if (isDateValid(minDate) && isDateValid(maxDate)) {
  //     return current.isAfter(moment(minDate).subtract(1, 'days')) && current.isSameOrBefore(maxDate)
  //   }
  // }

  const dateValue = (date) => {

    if (date) {
      const dateMoment = moment(date, DATE_TIME_FORMAT)
      return dateMoment.isValid() ? dateMoment.toDate() : null
      // return new Date(date)
    }
    return null
  }

  return (
    <>
      <div className="flex flex-col md:flex-row gap-2 justify-between">
        <CustomProvider locale={frFR}>
          <RDatePicker format="dd/MM/yyyy"
            value={dateValue(value)}
            disabled={disabled}
            shouldDisableDate={date => isBefore(date, subDays(minDate, 1)) || isAfter(date, maxDate)}
            onOk={handleChange}
            onClean={() => handleChange(null)}
            placement="autoVerticalStart"
            cleanable={true}
          />
          <RDatePicker format="HH:mm"
            value={dateValue(value)}
            disabled={disabled}
            onOk={handleChangeTime}
            placement="autoVerticalStart"
            cleanable={false}
          />
        </CustomProvider>
      </div>
      {/* <Datetime
        value={date}
        locale="fr-FR"
        onChange={setDate}
        onClose={handleChange}
        dateFormat="DD/MM/YYYY"
        timeFormat="HH:mm"
        isValidDate={valid}
        inputProps={{ className: className || '', disabled: disabled, id: id, onKeyDown: (e) => { e.preventDefault() }, inputmode: 'none' }}

      /> */}
      {/* <DatePicker
        selected={startDate}
        onChange={(date) => { setStartDate(date) handleChange(date) }}
        timeInputLabel={t('date_input.time_label')}
        dateFormat="MM/dd/yyyy h:mm aa"
        showTimeInput
        disabled={disabled}
        className={`w-full ${className}`}
        minDate={minDate}
        maxDate={maxDate}
        id={id}
      /> */}
    </>
  )
}

export default DateInput
